import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/air-api-constant";
import { StorageService } from 'src/app/air/modules/common/service/storage/storage.service';
import { BehaviorSubject, Observable, of } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class ShipmentService {
  private typeIndicatorInfo: any = {
    1: null,
    2: null,
    3: null,
    4: null,
  };
  public shipmentTypePromise = new BehaviorSubject<number>(0);
  public $shipmentTypeSubject = this.shipmentTypePromise.asObservable();


  private shipmentSearchPromise = new BehaviorSubject<any>(null);
  public $shipmentSearch = this.shipmentSearchPromise.asObservable();

  private recentShipmentPromise = new BehaviorSubject<any>(null);
  public $recentShipment = this.recentShipmentPromise.asObservable();

  private pinnedShipmentCountPromise = new BehaviorSubject<number>(0);
  public $pinnedShipment = this.pinnedShipmentCountPromise.asObservable();
  ETAThreshold: any;
  // containerNumbers: any = [];

  constructor(
    protected http: HttpClient,
    protected storageService: StorageService) { }

  getIntransitShipmentList(body: any = {}) {
    return this.http.post(settings.UserEndPoint.AirShipment.INTRANSIT_SHIPMENT_LIST, body);
  }

  //US 2851 In Transit List not showing all shipments on multi-shipment Vessel
  getVesselShipmentList(body: any = {}) {
    return this.http.post(settings.UserEndPoint.AirShipment.VESSEL_SHIPMENT_LIST, body);
  }

  getShipmentTypeIndicatorInfo(body: any = {}, isReload: boolean = true) {
    return new Promise((resolve, reject) => {
      if (isReload) {
        this.http.post(settings.UserEndPoint.Shipments.SHIPMENT_INDICATORS, body).subscribe((response: any) => {
          // this.typeIndicatorInfo[body.shipmentType] = response;
          resolve(response);
        }, reject);
      } else {
        resolve(this.typeIndicatorInfo[body.shipmentType]);
      }
    })
  }
//hjghyjgjygyu
  // getShipmentSearchlist(body: any = {}) {
  //   return this.http.post(settings.UserEndPoint.AirShipment.SHIPMENT_SEARCH, body);
  // }

  getShipmentResult(body: any = {}): Observable<any>{
  //  this.ETAThreshold = this.storageService.getItem('eta_threshold');
   // body.lateStatusMinRange = this.ETAThreshold.minLimit,
  //    body.lateStatusMaxRange = this.ETAThreshold.maxLimit
  //  body.etaConfigType = this.ETAThreshold.etaConfigType
  //  body.isFavoriteCall = 0;
    return this.http.post(settings.UserEndPoint.AirShipment.TRACKING_LIST_TAB, body);
  }

  //US 1912 Related New Method
  getRecentlyViewedShipments(body: any = {}) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
    body.lateStatusMinRange = this.ETAThreshold.minLimit,
      body.lateStatusMaxRange = this.ETAThreshold.maxLimit
    body.etaConfigType = this.ETAThreshold.etaConfigType
    body.isFavoriteCall = 0;
    return this.http.post(settings.UserEndPoint.Shipments.RECENTLY_VIEWED_SHIPMENTS, body);
  }

  getShipmentMetricsSummary(body: any = {}) {
    return of(
      [
        {
            "label": "On time Shipments",
            "data": 1553,
            "status": "Default +/- 5 days from the departure ETA vs. predicted ETA"
        },
        {
            "label": "Early Shipments",
            "data": 176,
            "status": "Default < -5 days from the departure ETA vs. predicted ETA"
        },
        {
            "label": "Late Shipments",
            "data": 192,
            "status": "Default > 5 days from departure ETA vs. predicted ETA"
        }
    ]
    )
    return this.http.post(settings.UserEndPoint.Shipments.SHIPMENT_METRICS_SUMMARY, body);
  }


  //Global search in app
  getShipmentSearch(body: any = {}) {
    return this.http.post(settings.UserEndPoint.AirShipment.GLOBAL_SHIPMENT_SEARCH, body);
  }

  public updateShipmentType(shipmentType: number = 0) {
    this.shipmentTypePromise.next(shipmentType);
  }

  public updateShipmentSearch(searchData: any) {
    this.shipmentSearchPromise.next(searchData);
  }

  getTrackingListDownload(body: any = {}) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
    body.lateStatusMinRange = this.ETAThreshold.minLimit,
      body.lateStatusMaxRange = this.ETAThreshold.maxLimit
    body.etaConfigType = this.ETAThreshold.etaConfigType
    body.isFavoriteCall = 0;
    return this.http.post(settings.UserEndPoint.Shipments.DOWNLOAD_TRACKING_LIST, body);
  }


  public updateRecentShipment(shipment: any, persist: boolean = false) {
    // console.log(shipment);
    if (!shipment.shipmentId) {
      this.recentShipmentPromise.next(null);
      return;
    }
    if (persist) {
      const email = this.storageService.getItem("email");
      const recentShipment = this.storageService.getItem('recentShipment-' + email);
      if (recentShipment) {
        for (let i = 0; i < recentShipment.length; i++) {
          if (recentShipment[i] == shipment.shipmentId) {
            recentShipment.splice(i, 1);
            break;
          }
        }
        if(shipment.shipmentStatus!==3)
          recentShipment.unshift("" + shipment.shipmentId);
        
        if (recentShipment.length > 15) {
          recentShipment.splice(15, 1);
        }
        this.storageService.setItem('recentShipment-' + email, recentShipment);
      } else {
        this.storageService.setItem('recentShipment-' + email, ["" + shipment.shipmentId]);
      }
    } else {
      this.recentShipmentPromise.next(shipment);
    }
  }

  public searchShipment(shipmentList: Array<any>, shipment: any) {
    let index = -1;
    for (let i = 0; i < shipmentList.length; i++) {
      if (shipmentList[i].shipmentId == shipment.shipmentId) {
        index = i;
        break;
      }
    }
    return index;
  }

  public updatePinnedShipmentCount(count: number) {
    this.pinnedShipmentCountPromise.next(count);
  }

  public getHardExceptionsResult() {
    // this.ETAThreshold = this.storageService.getItem('eta_threshold');
    // body.lateStatusMinRange = this.ETAThreshold.minLimit,
    //   body.lateStatusMaxRange = this.ETAThreshold.maxLimit
    // body.etaConfigType = this.ETAThreshold.etaConfigType
    // body.isFavoriteCall = 0;
    return this.http.get(settings.UserEndPoint.AirShipment.HARD_EXCEPTIONS_RESULT);
  }

  //This method will be used to set and get container numbers concated with comma(,)
  // public setContainerNumbers(containerNos: any) {
  //   this.containerNumbers = [];
  //   this.containerNumbers.push(containerNos);
  // }

}
